import VueObserveVisibility from 'vue3-observe-visibility'
import { defineNuxtPlugin } from '#imports'

export default defineNuxtPlugin(async (nuxtApp) => {
  nuxtApp.vueApp.use(VueObserveVisibility)
})
